require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./journal-10-to-12-lindsay-st-launched.json") })
        }
      }, "path---journal-10-to-12-lindsay-st-launched");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---journal-10-to-12-lindsay-st-launched!./.cache/json/journal-10-to-12-lindsay-st-launched.json
// module id = 445
// module chunks = 231608221292675